import "./styles/vars.css";
import "./styles/main.css";
import "./styles/ui-middle.css";
import "./styles/ui-top.css";
import "./styles/ui-right.css";
import "./styles/ui-left.css";
import "./styles/ui-bottom.css";
import "./styles/camera.css";
import "./styles/chat.css";
import "./styles/players-list.css";
import "./styles/other-modules.css"; 
import "./styles/sheets.css"; 

import { Main } from "./components/Main.mjs";

Main.init();